import { Container } from '@cleartrip/ct-design-components'
import { memo } from 'react'
import type { ReactNode } from 'react'

import TagsRow from './TagsRow'
import type { TupleMetaTag } from '../model/types'

export interface TupleMetaRowProps {
  tags: TupleMetaTag[]
  leading?: ReactNode
  trailing?: ReactNode
  density?: 'default' | 'compact'
}

const CSS_OUTER = { columnGap: 12, minWidth: 0, rowGap: 8 }
const CSS_INNER = { columnGap: 8, minWidth: 0, rowGap: 8 }
const CSS_TRAILING = { columnGap: 8 }

const TupleMetaRow: React.FC<TupleMetaRowProps> = ({ density = 'default', leading, tags, trailing }) => {
  const hasTags = tags.length > 0
  if (!leading && !hasTags && !trailing) return null

  return (
    <Container className='flex flex-baseline flex-between w-100p' css={CSS_OUTER}>
      <Container className='flex flex-middle flex-wrap flex-1' css={CSS_INNER}>
        {leading}
        {hasTags ? <TagsRow density={density} tags={tags} /> : null}
      </Container>
      {trailing ? (
        <Container className='flex flex-middle flex-no-shrink' css={CSS_TRAILING}>
          {trailing}
        </Container>
      ) : null}
    </Container>
  )
}

export default memo(TupleMetaRow)
